import { render, staticRenderFns } from "./HabilitarIgnVirtual.vue?vue&type=template&id=1dc90052"
import script from "./HabilitarIgnVirtual.vue?vue&type=script&lang=js"
export * from "./HabilitarIgnVirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports